module.exports = __webpack_public_path__ + "img/idea_reality@2x.34f67b8.webp";